var progress_bar = document.getElementById("progress-bar");
function loadingPage(){
    var loading_list = [
        {
            "id": "search",
            "content": "1. Searching and collecting the data.",
            "set_duration": loading_refreshing_time
        },
        {
            "id": "folder",
            "content": "2. Extracting keywords and trends.",
            "set_duration": loading_refreshing_time
        },
        {
            "id": "report",
            "content": "3. Compiling summary insights into visualisations.",
            "set_duration": loading_refreshing_time
        },
        {
            "id": "speech",
            "content": "4. AI is generating actionable recommendations.",
            "set_duration": loading_refreshing_time
        }, 
        {
            "id": "document",
            "content": "5. Preparing the final report.",
            "set_duration": loading_refreshing_time
        }
    ];


    // var lottie_player = document.getElementById("lottie-folder");
    // lottie_player[0].pause();
    var lottiePlayer = document.getElementsByTagName("lottie-player");
    progress_bar.style.animation = `progress-animation-strike-0-50 50s`;
   

    loading_list.map(function(item, index) {
        lottiePlayer[index].play();
        
        setTimeout(function() {
            textAnimation(item.id);
            $("#loading-"+ item.id).show();
            // $("#loading-"+ item.id).css("visibility", "visible");
            if(item.id == 'speech'){
                progress_bar.style.animation = `progress-animation-strike-50-95 30s`;
            }
            if(item.id == 'report'){
                checkCondition();
            }

            if(index>0){
                console.log("check lottie index", index)
                lottiePlayer[index-1].pause();
            }
    
            
            
        }, item.set_duration * index);
      
        // lottie_player[0].pause();
    });
}

function textAnimation (id){
    var textWrapper = document.querySelector('.text-animation.'+id);
    textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    anime.timeline({loop: false})
    .add({
        targets: '.text-animation.'+ id +' .letter',
        scale: [4,1],
        opacity: [0,1],
        translateZ: 0,
        easing: "easeOutExpo",
        duration: 950,
        delay: (el, i) => 70*i
    });

  

}



var trigger_count = 0; 
var doubled_once = false;
function checkCondition(){
    if (trigger_count >= 30) {
        // console.log("Trigger count exceeded 30, stopping further calls.");
        $('#loading_message').removeClass('d-none');
        return; // Stop further calls
    }

    var id = $("#report_id").val();
    $.ajax({
        type: 'POST',
        url: '/brand-social-report/loading',
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        data: {'id': id },
        success: function(data) {
            
            if (data.url) {
                progress_bar.style.width = "100%";
                progress_bar.style.animation = `progress-animation-strike-95-100 1s`;
                progress_bar.addEventListener("animationend", function (){
                    console.log("animation end");
                    window.location.href = data.url;
                });
            } else {
                // console.log("check data when fail", data);
                trigger_count++;
                if (trigger_count >= 5 && !doubled_once) {
                    loading_refreshing_time *= 2; // Double the refreshing time
                    doubled_once = true;
                }
                setTimeout(checkCondition, loading_refreshing_time);

                // Change the loading_subtitle based on the data received
                if (data.data.subtitle) {
                    $('#loading_subtitle').text(data.data.subtitle);
                }
            }
        },
        error:function(xhr, textStatus, errorThrown){
            // console.log("check again in 3 second");
            setTimeout(checkCondition, loading_refreshing_time);
        }
    });
}



module.exports = {
    loadingPage: loadingPage
};

$(function(){
    $("#btn_refresh").click(function(){
        window.location.reload();
    });
});
